<ntv-modal
    [isVisible]="isVisible()"
    (modalClose)="onClose()"
    size="medium"
    [grayBackground]="false"
    [showFooter]="true">
    <div modal-header class="filter-modal__header">
        <div class="header__content">
            <h1 class="header__title">Filter Media Files by User</h1>
            <p class="header__subtitle">Select Dealer, Host and Advertiser</p>
        </div>
        <svg class="icon icon--hoverable close-icon" width="23" height="23" (click)="onClose()">
            <use xlink:href="assets/icons/icons-sprite.svg#close"></use>
        </svg>
    </div>

    <app-dealer-selection-base
        [(selectedDealer)]="selectedDealer"
        [(selectedHost)]="selectedHost"
        [(selectedAdvertiser)]="selectedAdvertiser" />

    <div modal-footer class="filter-modal__footer">
        <ntv-button
            variant="accent"
            size="xl"
            [disabled]="disableFilterButton()"
            (buttonClick)="onFilter()">
            <span class="px-8">Filter</span>
        </ntv-button>
    </div>
</ntv-modal>
